import React, { useEffect } from 'react';

import { useRouter } from 'next/router';

import { mixpanelObject } from 'src/utils/analytics';
import { thumbnailPropertySetter } from 'src/utils/analytics/mixpanel/propertySetter';
import {
  externalUrlHandler,
  generateCardsUrl,
  navigationHandler
} from 'src/utils/cardsUrlGenerator';
import { CountryCode } from 'src/utils/constants/stringConstants';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CARD_NAME,
  MIXPANEL_CARD_RANK,
  MIXPANEL_ELEMENT,
  MIXPANEL_VERTICAL_INDEX
} from '../../../../utils/analytics/mixpanel/mixpanelConstants';
import {
  cardImpression,
  ctaEvent
} from '../../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import ThumbnailImage from '../../components/ThumbnailImage';
import { ThumbnailComponentProps } from '../../types';
import * as customStyled from './styles';
import { ExternalLinkEnums } from '../../../../utils/constants/AppConstants';

const BellyBanner: React.FC<ThumbnailComponentProps> = ({
  title,
  tags,
  tagName,
  imageUrl,
  slug,
  assetSubType,
  assetType,
  businessType,
  billingType,
  content,
  cardDetails,
  thumbnailType,
  contentPartner,
  content_partner_details,
  joystickIconCheck
}) => {
  const { appConfig, usersLocationData } = useAppStore();

  const router = useRouter();

  let slugData = content ? generateCardsUrl(content) ?? slug : '';
  if (slugData && assetSubType !== ExternalLinkEnums.EXTERNAL_LINK) {
    slugData = slugData.startsWith('/') ? slugData : `/${slugData}`;
  }

  if (
    appConfig.isRequestedByBot &&
    usersLocationData?.country_code !== CountryCode.IN
  ) {
    const globalRegex = /\/global\//;
    slugData = slugData
      .replace(globalRegex, '/')
      .replace(`/${router.locale}/`, '/');
  }

  useEffect(() => {
    triggerBellyBannerLoadMixpanelEvents();
  }, []);

  const triggerBellyBannerLoadMixpanelEvents = () => {
    mixpanelObject[MIXPANEL_CARD_NAME] = cardDetails?.title;
    mixpanelObject[MIXPANEL_CARD_RANK] = cardDetails?.horizontalIndex;
    mixpanelObject[MIXPANEL_VERTICAL_INDEX] = cardDetails?.horizontalIndex;
    cardImpression();
  };

  const triggerBellyBannerClickMixpanelEvents = () => {
    mixpanelObject[MIXPANEL_ELEMENT] =
      cardDetails?.title || cardDetails?.originalTitle;
    mixpanelObject[MIXPANEL_BUTTON_TYPE] = cardDetails?.horizontalIndex;
    ctaEvent();
  };

  const watchCallback = (e: React.MouseEvent) => {
    window.storeMixPanelMetricsInSS('CLICKED_EVT', Date.now());
    e.preventDefault();
    if (slugData) {
      thumbnailPropertySetter({
        item: {
          title,
          imageUrl,
          businessType,
          billingType,
          tags,
          assetSubType,
          link: slug
        }
      });
      if (slugData && assetSubType === ExternalLinkEnums.EXTERNAL_LINK) {
        externalUrlHandler(slugData, triggerBellyBannerClickMixpanelEvents);
      } else {
        navigationHandler(slugData, (slugData) => {
          triggerBellyBannerClickMixpanelEvents();
          //Hanlding diwali offer belly banner which is not applicable for global. Hence no, globalURL handling.
          router.push(slugData, slugData);
        });
      }
    }
  };
  return (
    <div
      title={title}
      className="keen-slider__slide"
      css={customStyled.container}>
      <div css={customStyled.contentItemCard}>
        <ThumbnailImage
          imageUrl={imageUrl}
          tagName={tagName}
          assetType={assetType}
          title={title}
          slug={slugData}
          businessType={businessType}
          billingType={billingType}
          onClickHandler={watchCallback}
          thumbnailType={thumbnailType}
          contentPartner={contentPartner}
          content_partner_details={content_partner_details}
          joystickIconCheck={joystickIconCheck}
        />
      </div>
    </div>
  );
};

export default BellyBanner;
